module.exports={turnstile_modal:{message:"التحقق من تفاصيل الأمان"}};